import React, { FC, useState, ImgHTMLAttributes } from 'react'

export interface ImgLoadProps<T> extends ImgHTMLAttributes<T> {
    className?: string
    loadingImg?: string
    errorImg?: string
    src: string
}

export const ImgLoad: FC<ImgLoadProps<any>> = props => {
    const [src, setSrc] = useState(props.loadingImg as string)
    const [isFlag, setIsFlag] = useState(false)
    const handleOnLoad = () => {
        if (isFlag) return
        const imgDom = new Image()
        imgDom.src = props.src
        imgDom.onload = function () {
            setIsFlag(true)
            setSrc(props.src)
        }
        imgDom.onerror = function () {
            setIsFlag(true)
            setSrc(props.errorImg as string)
        }
    }

    return (
        <>
            <img className={props.className} src={src} onLoad={handleOnLoad} alt="" />
        </>
    )
}
